import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'core_collections-sticky_cart_collection_page_view_bag-click';
/**
 * Click View Bag (collectionToken, brandToken)
 */
export function trackCoreCollectionsStickyCartCollectionPageViewBagClick(productBasedCollectionToken, brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { productBasedCollectionToken, brandToken },
    });
}
